<script>
import {mapActions} from "vuex";

export default {
  name: "footerSection",
  data() {
    return {
      activeNames: [],
      states: [],
      availableStates: [],
      searchFiltersForm: {
        sort: "time",
        saleType: "1",
        propertyTypeList: ["All"],
        minPrice: "Any",
        maxPrice: "Any",
        minRentalEstimate: "Any",
        maxRentalEstimate: "Any",
        minLandSize: "Any",
        maxLandSize: "Any",
        minBuildSize: "Any",
        maxBuildSize: "Any",
        minBedrooms: "Any",
        maxBedrooms: "Any",
        bathrooms: "Any",
        carSpaces: "Any",
        searchSuburb: ""
      },
      selectedState:"",
      selectedPropertyType:"buy",
    };
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    redirectToHome() {
      this.$router.push({ path: "/homepage" });
    },
    redirectToAboutUs() {
      this.$router.push({ path: "/about" });
    },
    redirectToContactUs() {
      this.$router.push({ path: "/contactus" });
    },
    ...mapActions("home", ["getAllStates"]),
    getAllStatesCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.availableStates = res.data.data;
        for(let state of this.availableStates){
          this.states.push(state);
        }

      } else {

      }
    },
    changeState(state) {
      this.selectedState = state;
      this.goToQuickSearch();
    },
    changePropertyType(propertyType) {
      this.selectedPropertyType = propertyType;
      this.goToQuickSearch();
    },
    goToBlog(){
      if (this.$route.path !== "/blog") {
        this.$router.push("/blog");
      } else {
        this.$router.go();
      }
    },
    goToAdvertise(){
      if (this.$route.path !== "/advertise-with-unifi-property-com") {
        this.$router.push("/advertise-with-unifi-property-com");
      } else {
        this.$router.go();
      }
    },
    redirectToTermsAndConditions() {
      // if (this.$route.path !== "/terms-and-conditions") {
      //   this.$router.push("/terms-and-conditions");
      // } else {
      //   this.reload();
      // }
      window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/terms-and-conditions/UNIFI-Property-Terms-and-Conditions.pdf", '_blank');
    },
    redirectToPrivacyPolicy(){
      // if(this.$route.path !== "/privacyPolicy"){
      //   this.$router.push("/privacyPolicy");
      // }else{
      //   this.reload();
      // }
      window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/privacy-policy/UNIFI-Property-Privacy-Policy.pdf", '_blank');
    },
    goToQuickSearch() {
      //get for SA only for now, and fix up post go live

      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;

      console.log("this.searchType: ", this.searchType);

      // this.searchFiltersForm.searchType = this.searchType
      if (this.searchFiltersForm.searchSuburb) {
        this.searchFiltersForm.searchSuburb = this.searchFiltersForm.searchSuburb.replace(
          " SA, Australia",
          ""
        );
      }
      //set search Property Type
      if(this.selectedPropertyType === 'sold'){
        options.searchType = "sold";
      }else{
        options.searchType = "buy";
      }

      //set search State
      switch (this.selectedState) {
        case "New South Wales":
          options.searchSuburb = "New South Wales";
          break;
        case "Queensland":
          options.searchSuburb = "Queensland";
          break;
        case "Victoria":
          options.searchSuburb = "Victoria";
          break;
        case "Australian Capital Territory":
          options.searchSuburb = "Australian Capital Territory";
          break;
        case "South Australia":
          options.searchSuburb = "South Australia";
          break;
        case "Western Australia":
          options.searchSuburb = "Western Australia";
          break;
        case "Tasmania":
          options.searchSuburb = "Tasmania";
          break;
        case "Northern Territory":
          options.searchSuburb = "Northern Territory";
          break;
        default:
          options.searchSuburb = "Australia";
          break;
      }

      this.searchFiltersForm= options;

      sessionStorage.setItem("isSearch", "1");
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(this.searchFiltersForm)
      );
      if (this.$route.path !== "/property/search/results") {
        this.$router.push("/property/search/results");
      } else {
        this.$router.go();
      }
    },
  },
  mounted() {
    this.$refs.collapse.$el.scrollIntoView(false);
  },
  created() {
    this.getAllStates({callback: this.getAllStatesCallback});
  },
};
</script>

<template>
  <el-row class="footer-wrapper" >
    <el-col
      :span="24"
      style="display: flex; justify-content: center; align-items: center;padding: 40px 0 45px 0"
    >
      <img
        alt="UNIFI Property"
        src="../../assets/unifi-logo-new-with-text-white.svg"
        style="width: 250px; height: 48px"
        @click="redirectToHome"
      />
    </el-col>
<!--    <el-col :span="24" style="padding: 0 15px">-->
<!--      <el-collapse ref="collapse" v-model="activeNames" @change="handleChange">-->
<!--        <el-collapse-item name="1">-->
<!--          <template slot="title"-->
<!--            ><span class="font-style-collapse" style="padding: 0 15px;"-->
<!--              >UNIFI Property</span-->
<!--            >-->
<!--          </template>-->
<!--          <el-row :gutter="20" style="padding: 10px">-->
<!--            <el-col :span="24">-->
<!--              <div style="margin-top: 5px;">-->
<!--                <span class="font-style-desc"-->
<!--                  >Buy tomorrow’s Real Estate Today<br /><br-->
<!--                /></span>-->
<!--                <span class="font-style-desc">Ready to find your new home? Explore our range of brand-new and off-the-plan properties today. Whether you're looking for a stylish apartment in the city, a family home in a new development, or an investment opportunity, <span style="font-weight: 600">UNIFI Property</span> is here to help you find it.</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-collapse-item>-->
<!--        <el-collapse-item name="2">-->
<!--          <template slot="title"-->
<!--            ><span class="font-style-collapse" style="padding: 0 15px;"-->
<!--              >Need help?</span-->
<!--            ></template-->
<!--          >-->
<!--          <el-row :gutter="20" style="padding: 10px">-->
<!--            <el-col :span="24">-->
<!--              <div style="margin-top: 5px;">-->
<!--                <span class="font-style-desc"-->
<!--                  >If you would like to report a problem, or if you would like-->
<!--                  some further assistance. Please email us at-->
<!--                  team@unifiproperty.com. We look forward to chatting with-->
<!--                  you.</span-->
<!--                >-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-collapse-item>-->
<!--        <el-collapse-item name="3">-->
<!--          <template slot="title"-->
<!--          ><span class="font-style-collapse" style="padding: 0 15px;"-->
<!--          >Find your property</span-->
<!--          ></template-->
<!--          >-->
<!--          <el-row :gutter="20" style="padding: 10px">-->
<!--            <el-col :span="24" style="display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start">-->
<!--              <div style="margin-top: 5px; padding: 20px;" @click="changePropertyType('buy')">-->
<!--                <span class="font-style-desc">Buy</span>-->
<!--              </div>-->
<!--              <div style="margin-top: 5px; padding: 20px;" @click="changePropertyType('sold')">-->
<!--                <span class="font-style-desc">Sold</span>-->
<!--              </div>-->
<!--&lt;!&ndash;              <div style="margin-top: 5px; padding: 20px;">&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="font-style-desc">Hot Property</span>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-collapse-item>-->
<!--        <el-collapse-item name="4">-->
<!--          <template slot="title"-->
<!--          ><span class="font-style-collapse" style="padding: 0 15px;"-->
<!--          >Info</span-->
<!--          ></template-->
<!--          >-->
<!--          <el-row :gutter="20" style="padding: 10px">-->
<!--            <el-col :span="24" style="display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-start">-->
<!--&lt;!&ndash;              <div style="margin-top: 5px; padding: 20px;">&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="font-style-desc">Our Agents</span>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--              <div style="margin-top: 5px; padding: 5px;">-->
<!--                <span class="font-style-desc" @click="redirectToAboutUs">About Us</span>-->
<!--              </div>-->
<!--              <div style="margin-top: 5px; padding: 5px;">-->
<!--                <span class="font-style-desc" @click="redirectToContactUs">Contact Us</span>-->
<!--              </div>-->
<!--              <div style="margin-top: 5px; padding: 5px;">-->
<!--                <span class="font-style-desc" @click="goToAdvertise">Advertise with us</span>-->
<!--              </div>-->
<!--              <div style="margin-top: 5px; padding: 5px;">-->
<!--                <span class="font-style-desc" @click="goToBlog">Blog</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-collapse-item>-->
<!--        <el-collapse-item name="5">-->
<!--          <template slot="title"-->
<!--          ><span class="font-style-collapse" style="padding: 0 15px;"-->
<!--          >Location</span-->
<!--          ></template-->
<!--          >-->
<!--          <el-row :gutter="20" style="padding: 10px">-->
<!--            <el-col :span="24" style="display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start">-->
<!--              <div v-if="states.includes('New South Wales')" style="margin-top: 5px; padding: 20px;" @click="changeState('New South Wales')">-->
<!--                <span class="font-style-desc">NSW</span>-->
<!--              </div>-->
<!--              <div v-if="states.includes('Queensland')" style="margin-top: 5px; padding: 20px;"  @click="changeState('Queensland')">-->
<!--                <span class="font-style-desc">QLD</span>-->
<!--              </div>-->
<!--              <div v-if="states.includes('Victoria')" style="margin-top: 5px; padding: 20px;" @click="changeState('Victoria')">-->
<!--                <span class="font-style-desc">VIC</span>-->
<!--              </div>-->
<!--              <div v-if="states.includes('South Australia')" style="margin-top: 5px; padding: 20px;" @click="changeState('South Australia')">-->
<!--                <span class="font-style-desc">SA</span>-->
<!--              </div>-->
<!--              <div v-if="states.includes('Australian Capital Territory')" style="margin-top: 5px; padding: 20px;" @click="changeState('Australian Capital Territory')">-->
<!--                <span class="font-style-desc">ACT</span>-->
<!--              </div>-->
<!--              <div  v-if="states.includes('Western Australia')" style="margin-top: 5px; padding: 20px;" @click="changeState('Western Australia')">-->
<!--                <span class="font-style-desc">WA</span>-->
<!--              </div>-->
<!--              <div  v-if="states.includes('Northern Territory')" style="margin-top: 5px; padding: 20px;" @click="changeState('Northern Territory')">-->
<!--                <span class="font-style-desc">NT</span>-->
<!--              </div>-->
<!--              <div v-if="states.includes('Tasmania')" style="margin-top: 5px; padding: 20px;" @click="changeState('Tasmania')">-->
<!--                <span class="font-style-desc">TAS</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-collapse-item>-->
<!--      </el-collapse>-->
<!--    </el-col>-->
    <el-col :span="24">
      <el-row style="padding: 40px 15px">
        <el-col
          :sm="24"
          :span="24"
          :xs="24"
          class="centered-social-icon"
          style="gap: 30px"
        >
          <a href="https://www.facebook.com/unifiproperty" target="_blank">
            <img alt="Facebook" src="../../assets/facebook48x48.png" />
          </a>
          <a href="https://www.instagram.com/unifiproperty/" target="_blank">
            <img alt="Instagram" src="../../assets/instagram48x48.png" />
          </a>
          <!--        <img alt="X" src="../../assets/x48x48.png"/>-->
        </el-col>
        <el-col
          :sm="24"
          :span="24"
          :xs="24"
          class="centered-social-icon"
          style="color: #FFF; padding: 20px 0 0 0;display: flex; flex-direction: column"
        >
            <span class="font-style-policy" @click="redirectToPrivacyPolicy">Privacy Policy</span><br/>
            <span class="font-style-policy" @click="redirectToTermsAndConditions">Terms &amp; Conditions</span>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="24">
      <div
        class="footer-copyright-wrapper">
        <span class="footer-copyright-text" style="padding: 10px 0"
          >&copy; {{ new Date().getFullYear() }} UNIFI Property, All rights
          reserved</span
        >
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.footer-wrapper {
  background: radial-gradient(circle at bottom right, #003030 70%, #121312 100%);
}
.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.font-style-policy {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.footer-copyright-wrapper {
  background-color: #003333;
  display: flex;
  justify-content: center;
}
.footer-copyright-text {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

.font-style-collapse {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.font-style-desc {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}

.padding-tc {
  padding: 20px 0;
}

.el-collapse {
  border-top: none;
}

.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #003333;
  color: #ffffff;
}

.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #003333;
}

.el-collapse-item /deep/ .el-collapse-item__content {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/package/footerSection.vue